"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDevicePixelRatio = getDevicePixelRatio;
exports.useDevicePixelRatio = useDevicePixelRatio;
var react_1 = require("react");
function getDevicePixelRatio() {
    if (typeof window === 'undefined') {
        return undefined;
    }
    if (typeof window.devicePixelRatio !== 'number') {
        return undefined;
    }
    return window.devicePixelRatio;
}
/**
 * Track the device pixel ratio of the current window, also through it changing
 *
 * @param options.round     (default: true) rounds the ratio to closest integer value
 * @param options.min       (default: 1) the minimum value the ratio can take
 * @param options.max       (default: undefined) the maximum value the ratio can take
 * @param options.fallback  (default: 1) the default ratio to use in case determining the ratio is not possible
 *
 * @returns Device pixel ratio of the current window
 */
function useDevicePixelRatio(options) {
    var _a = options !== null && options !== void 0 ? options : {}, _b = _a.round, round = _b === void 0 ? true : _b, _c = _a.min, min = _c === void 0 ? 1 : _c, _d = _a.fallback, fallback = _d === void 0 ? 1 : _d, max = _a.max;
    var getNormalisedPixelRatio = (0, react_1.useCallback)(function () {
        var _a;
        var raw = (_a = getDevicePixelRatio()) !== null && _a !== void 0 ? _a : fallback;
        var rounded = round ? Math.round(raw) : raw;
        if (max !== undefined) {
            return Math.min(max, Math.max(min, rounded));
        }
        return Math.max(min, rounded);
    }, [getDevicePixelRatio, round, min, max, fallback]);
    var _e = (0, react_1.useState)(getNormalisedPixelRatio()), ratio = _e[0], setRatio = _e[1];
    (0, react_1.useEffect)(function () {
        var canListen = typeof window !== 'undefined' && 'matchMedia' in window;
        if (!canListen) {
            return;
        }
        var updateRatio = function () { return setRatio(getNormalisedPixelRatio()); };
        var mediaMatcher = window.matchMedia("screen and (resolution: ".concat(ratio, "dppx)"));
        mediaMatcher.addEventListener('change', updateRatio);
        return function () {
            mediaMatcher.removeEventListener('change', updateRatio);
        };
    }, [ratio, getNormalisedPixelRatio]);
    return ratio;
}
//# sourceMappingURL=use_device_pixel_ratio.js.map